import TemplateWizardLandingPage from './TemplateWizardLandingPage';

export default TemplateWizardLandingPage;
